import { DataTableSearchService } from "aes-datatables";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SenetData } from "aes-datatables";
import { Injectable } from "@angular/core";
import { CRUDService, Message } from "aes-common";

export interface AccountAPIKey {
    apikey: string;
    creationDate: string;
    apiKeyId: string;
    acctId: number;
}
@Injectable()
export class AESAccountAPIKeysService implements DataTableSearchService<AccountAPIKey>, CRUDService<AccountAPIKey>{

    constructor(private http: HttpClient) { }

    create(object: AccountAPIKey): Observable<Message> {
        const href = 'accounts/apikeys';
        var requestUrl = `${href}`

        return this.http.post<Message>(requestUrl, object);
    }
    edit(object: AccountAPIKey): Observable<Message> {
        const href = 'accounts/apikeys';
        var requestUrl = `${href}`

        return this.http.put<Message>(requestUrl, object);
    }
    delete(object: AccountAPIKey): Observable<Message> {
        const href = 'accounts/apikeys';
        var params = new HttpParams().set("apikey", object.apikey);
        var requestUrl = `${href}`

        return this.http.delete<Message>(requestUrl, {
            params : params
        });
    }

    search(sort: string, order: string, page: number, search: string, limit: number, customFilter: any): Observable<SenetData<AccountAPIKey>> {
        const href = 'accounts/apikeys';
        var offset = page * limit;
        var requestUrl = `${href}`;
        var params = new HttpParams();
        if(sort != undefined && sort != ""){
            params = params.set("sort", sort);
        }
        if(!isNaN(limit)){
            params = params.set("limit", limit.toString());
        }
        if(order != undefined){
            params = params.set("sortDir", order);          
        }
        if(!isNaN(offset)){
            params = params.set("offset", offset.toString());
        }
        if (search != undefined && search != "") {
            params = params.set("search", search);
        }

        return this.http.get<SenetData<AccountAPIKey>>(requestUrl, {
            params : params
        });
    }
}